import { render } from "./TramiteConsulta.vue?vue&type=template&id=01365273&scoped=true"
import script from "./TramiteConsulta.vue?vue&type=script&lang=js"
export * from "./TramiteConsulta.vue?vue&type=script&lang=js"

import "./TramiteConsulta.vue?vue&type=style&index=0&id=01365273&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01365273"]])

export default __exports__